"use client";

import RouterLink from "@/components/ui/router-link";
import useLocaleRouter from "@/hooks/useLocaleRouter";
import { useScopedI18n } from "@/messages/client";
import { usePathname, useSearchParams } from "next/navigation";
import { useMemo } from "react";
import * as NProgress from "nprogress";
import { useUser } from "@/components/clients/LocaleToStorage";
import { User } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { mutate } from "swr";

export default function UserInfo() {
  const t = useScopedI18n("全局导航条");

  const { user, isLoading, clearToken } = useUser();

  const router = useLocaleRouter();

  const pathname = usePathname();

  const searchParams = useSearchParams();

  const redirect_url = useMemo(() => {
    if (pathname.includes("/login")) {
      return "";
    }

    const query = searchParams.toString();

    return encodeURI(`${pathname}${query ? `?${query}` : ""}`);
  }, [pathname, searchParams]);

  if (isLoading) {
    return (
      <div className="flex items-center">
        <Skeleton className="ml-2 h-6 w-20 bg-slate-100" />
      </div>
    );
  }

  return (
    <div className="flex items-center">
      {!user ? (
        <div className="flex items-center text-sm text-[#FF5100]">
          <div
            className="cursor-pointer underline-offset-2 hover:underline"
            onClick={() => {
              NProgress.start();
              router.push(`/login?redirect_url=${redirect_url}`);
              NProgress.done();
            }}>
            {t("登录")}
          </div>
          <span className="mx-0.5">/</span>
          <RouterLink
            href="/register"
            className="cursor-pointer underline-offset-2 hover:underline">
            {t("注册")}
          </RouterLink>
        </div>
      ) : (
        <div className="text-gray-700 flex pl-2 text-sm">
          <HoverCard openDelay={300}>
            <HoverCardTrigger asChild className="h-5 min-w-[36px] cursor-pointer underline-offset-4 hover:text-primary hover:underline">
              <div className="flex items-center space-x-1">
                <User size={18} />
                <span>{user?.first_name ?? "-"}</span>
              </div>
            </HoverCardTrigger>
            <HoverCardContent
              className="max-w-[100px] rounded-md !border-[#E6E6E6] bg-white p-0"
              sideOffset={10}>
              <div
                className="cursor-pointer p-2 text-center underline-offset-2 hover:text-primary hover:underline"
                onClick={() => {
                  NProgress.start();

                  window.localStorage.removeItem("token");

                  clearToken?.();

                  mutate("/api/me", null, false);

                  router.refresh()

                  NProgress.done();
                }}>
                {t("退出登录")}
              </div>
            </HoverCardContent>
          </HoverCard>
        </div>
      )}
    </div>
  );
}
